import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICentro } from '@models/ICentros';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class CentroService {
  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) {}

  // 6.1. GET: Funcion que devuelve los centros de un cliente
  getCentros(): Observable<ICentro[]> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    return this.http.get<ICentro[]>(
      `${environment.API_URL}cliente/centro/all`,
      {
        params: {
          idOperador: String(idOperador),
        },
      },
    );
  }

  // 6.2. GET: Funcion que devuelve los centros de un cliente en los que se puede reclamar
  getCentrosReclamaciones(): Observable<ICentro[]> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    return this.http.get<ICentro[]>(
      `${environment.API_URL}cliente/centro/reclamaciones/all`,
      {
        params: {
          idOperador: String(idOperador),
        },
      },
    );
  }

  // GET: Funcion que devuelve los centros de un cliente en los que se puede realizar transito
  // ? EN LA 1.0 AL ENTRAR AL NOTIFICAR INVENTARIO SE LLAMA A GETCENTROSTRASITO PERO CUANDO SE USA EN EL HTML ESTA COMENTADO
  getCentrosTransitos(): Observable<ICentro[]> {
    const idOperador = this.userService.getUserInfo()?.idOperador;
    return this.http.get<ICentro[]>(
      `${environment.API_URL}cliente/centro/transito/all`,
      {
        params: {
          idOperador: String(idOperador),
        },
      },
    );
  }
  

  // seleccionarCentro(centro: ICentro) {
  //   throw new Error('Method not implemented.');
  //   // this.centroSeleccionado = centro;
  // }

}
